import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  MetaverseLabSection,
  SectionTitle,
  SectionSubtitle,
  LabContent,
  LabInfo,
  LabDescription,
  LabFeatures,
  FeatureItem,
  LabVisual,
  Card,
  CardIcon,
  CardTitle,
  CardContent
} from './styles';

const MetaverseLab: React.FC = () => {
  const { language } = useLanguage();
  return (
    <MetaverseLabSection>
      <div className="container">
        <SectionTitle>{language === 'pt' ? 'NOSSOS SERVIÇOS' : 'OUR SERVICES'}</SectionTitle>
        <SectionSubtitle>
          {language === 'pt' 
            ? 'Oferecemos soluções tecnológicas completas para impulsionar seu negócio'
            : 'We offer complete technological solutions to boost your business'}
        </SectionSubtitle>
        
        <LabContent>
          <LabInfo>
            <LabDescription>
              {language === 'pt' ? (
                <>
                  <p>
                    Nosso laboratório de pesquisa de metaverso é um espaço dedicado à exploração e 
                    desenvolvimento de tecnologias imersivas que estão moldando o futuro da interação 
                    digital. Combinamos expertise em realidade virtual, aumentada e mista para criar 
                    experiências que transcendem os limites do mundo físico.
                  </p>
                  <p>
                    Trabalhamos na vanguarda da inovação, desenvolvendo aplicações práticas para 
                    diversos setores, desde educação e treinamento até entretenimento e saúde. 
                    Nossa equipe multidisciplinar une conhecimentos em programação, design 3D, 
                    psicologia cognitiva e experiência do usuário para criar ambientes virtuais 
                    intuitivos e envolventes.
                  </p>
                </>
              ) : (
                <>
                  <p>
                    Our metamorphose research laboratory is a space dedicated to exploring and 
                    developing immersive technologies that are shaping the future of digital interaction. 
                    We combine expertise in virtual, augmented, and mixed reality to create 
                    experiences that transcend the limits of the physical world.
                  </p>
                  <p>
                    We work at the forefront of innovation, developing practical applications for 
                    various sectors, from education and training to entertainment and healthcare. 
                    Our multidisciplinary team combines knowledge in programming, 3D design, 
                    cognitive psychology, and user experience to create intuitive and engaging virtual environments.
                  </p>
                </>
              )}
            </LabDescription>
            
            <Card>
            <CardIcon>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M13,19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H4A1,1 0 0,1 3,16V12A1,1 0 0,1 4,11H20A1,1 0 0,1 21,12V16A1,1 0 0,1 20,17H13V19M4,3H20A1,1 0 0,1 21,4V8A1,1 0 0,1 20,9H4A1,1 0 0,1 3,8V4A1,1 0 0,1 4,3M5,5V7H19V5H5Z" />
              </svg>
            </CardIcon>
            <CardTitle>{language === 'pt' ? 'Desenvolvimento de Software' : 'Software Development'}</CardTitle>
            <CardContent>
              {language === 'pt' 
                ? 'Criamos soluções de software personalizadas, desde aplicativos móveis e sistemas web até plataformas empresariais complexas, utilizando as mais modernas tecnologias.'
                : 'We create customized software solutions, from mobile applications and web systems to complex enterprise platforms, using the most modern technologies.'}
            </CardContent>
          </Card>
          
          <Card>
            <CardIcon>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12,2A9,9 0 0,0 3,11C3,14.03 4.53,16.82 7,18.47V22H9V19H11V22H13V19H15V22H17V18.46C19.47,16.81 21,14 21,11A9,9 0 0,0 12,2M8,11A2,2 0 0,1 10,13A2,2 0 0,1 8,15A2,2 0 0,1 6,13A2,2 0 0,1 8,11M16,11A2,2 0 0,1 18,13A2,2 0 0,1 16,15A2,2 0 0,1 14,13A2,2 0 0,1 16,11M12,14L13.5,17H10.5L12,14Z" />
              </svg>
            </CardIcon>
            <CardTitle>{language === 'pt' ? 'Inteligência Artificial' : 'Artificial Intelligence'}</CardTitle>
            <CardContent>
              {language === 'pt' 
                ? 'Implementamos soluções de IA para automatizar processos, analisar dados e criar experiências personalizadas que transformam a maneira como as empresas operam.'
                : 'We implement AI solutions to automate processes, analyze data, and create personalized experiences that transform the way companies operate.'}
            </CardContent>
          </Card>
          
          <Card>
            <CardIcon>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12,3C10.73,3 9.6,3.8 9.18,5H3V7H4.95L2,14C1.53,16 3,17 5.5,17C8,17 9.56,16 9,14L6.05,7H9.17C9.5,7.85 10.15,8.5 11,8.83V20H2V22H22V20H13V8.82C13.85,8.5 14.5,7.85 14.82,7H17.95L15,14C14.53,16 16,17 18.5,17C21,17 22.56,16 22,14L19.05,7H21V5H14.83C14.4,3.8 13.27,3 12,3M12,5A1,1 0 0,1 13,6A1,1 0 0,1 12,7A1,1 0 0,1 11,6A1,1 0 0,1 12,5M5.5,10.25L7,14H4L5.5,10.25M18.5,10.25L20,14H17L18.5,10.25Z" />
              </svg>
            </CardIcon>
            <CardTitle>{language === 'pt' ? 'Consultoria Tecnológica' : 'Technology Consulting'}</CardTitle>
            <CardContent>
              {language === 'pt' 
                ? 'Oferecemos consultoria especializada para ajudar empresas a identificar oportunidades, implementar novas tecnologias e otimizar seus processos digitais.'
                : 'We offer specialized consulting to help companies identify opportunities, implement new technologies, and optimize their digital processes.'}
            </CardContent>
          </Card>
          </LabInfo>
          
          <LabVisual>
            <img src="/back_imgs/services.png" alt="Metaverse Lab" style={{ width: '100%', height: 'auto', borderRadius: '10px' }} />
          </LabVisual>
        </LabContent>
      </div>
    </MetaverseLabSection>
  );
};

export default MetaverseLab;